// extracted by mini-css-extract-plugin
module.exports = {"productsWork":"WorksComponent_productsWork__QmJna"};